//  alert
Vue.component('b-alert',() => import(/* webpackChunkName: "b-alert" */ '@bv/alert/alert').then(m => {return m.BAlert}))

//  aspect
Vue.component('b-aspect',() => import(/* webpackChunkName: "b-aspect" */ '@bv/aspect/aspect').then(m => {return m.BAspect}))

//  avatar
Vue.component('b-avatar',() => import(/* webpackChunkName: "b-avatar" */ '@bv/avatar/avatar').then(m => {return m.BAvatar}))
Vue.component('b-avatar-group',() => import(/* webpackChunkName: "b-avatar-group" */ '@bv/avatar/avatar-group').then(m => {return m.BAvatarGroup}))

//  badge
Vue.component('b-badge', () => import(/* webpackChunkName: "b-badge" */ '@bv/badge/badge').then(m => {return m.BBadge}))

//  breadcrumb
Vue.component('b-breadcrumb', () => import(/* webpackChunkName: "b-breadcrumb" */ '@bv/breadcrumb/breadcrumb').then(m => {return m.BBreadcrumb}))
Vue.component('b-breadcrumb-item', () => import(/* webpackChunkName: "b-breadcrumb-item" */ '@bv/breadcrumb/breadcrumb-item').then(m => {return m.BBreadcrumbItem}))

//  button
Vue.component('b-button', () => import(/* webpackChunkName: "b-button" */ '@bv/button/button').then(m => {return m.BButton}))
Vue.component('b-button-close', () => import(/* webpackChunkName: "b-button-close" */ '@bv/button/button-close').then(m => {return m.BButtonClose}))

//  button-group
Vue.component('b-button-group', () => import(/* webpackChunkName: "b-button-group" */ '@bv/button-group/button-group').then(m => {return m.BButtonGroup}))

//  button-toolbar
Vue.component('b-button-toolbar', () => import(/* webpackChunkName: "b-button-toolbar" */ '@bv/button-toolbar/button-toolbar').then(m => {return m.BButtonToolbar}))

//  calendar
Vue.component('b-calendar', () => import(/* webpackChunkName: "b-calendar" */ '@bv/calendar/calendar').then(m => {return m.BCalendar}))

//  card
Vue.component('b-card', () => import(/* webpackChunkName: "b-card" */ '@bv/card/card').then(m => {return m.BCard}))
Vue.component('b-card-header', () => import(/* webpackChunkName: "b-card-header" */ '@bv/card/card-header').then(m => {return m.BCardHeader}))
Vue.component('b-card-footer', () => import(/* webpackChunkName: "b-card-footer" */ '@bv/card/card-footer').then(m => {return m.BCardFooter}))
Vue.component('b-card-body', () => import(/* webpackChunkName: "b-card-body" */ '@bv/card/card-body').then(m => {return m.BCardBody}))
Vue.component('b-card-title', () => import(/* webpackChunkName: "b-card-title" */ '@bv/card/card-title').then(m => {return m.BCardTitle}))
Vue.component('b-card-sub-title', () => import(/* webpackChunkName: "b-card-sub-title" */ '@bv/card/card-sub-title').then(m => {return m.BCardSubTitle}))
Vue.component('b-card-img', () => import(/* webpackChunkName: "b-card-img" */ '@bv/card/card-img').then(m => {return m.BCardImg}))
Vue.component('b-card-img-lazy', () => import(/* webpackChunkName: "b-card-img-lazy" */ '@bv/card/card-img-lazy').then(m => {return m.BCardImgLazy}))
Vue.component('b-card-text', () => import(/* webpackChunkName: "b-card-text" */ '@bv/card/card-text').then(m => {return m.BCardText}))
Vue.component('b-card-group', () => import(/* webpackChunkName: "b-card-group" */ '@bv/card/card-group').then(m => {return m.BCardGroup}))

//  carousel
Vue.component('b-carousel', () => import(/* webpackChunkName: "b-carousel" */ '@bv/carousel/carousel').then(m => {return m.BCarousel}))
Vue.component('b-carousel-slide', () => import(/* webpackChunkName: "b-carousel-slide" */ '@bv/carousel/carousel-slide').then(m => {return m.BCarouselSlide}))

//  collapse
Vue.component('b-collapse', () => import(/* webpackChunkName: "b-collapse" */ '@bv/collapse/collapse').then(m => {return m.BCollapse}))

//  dropdown
Vue.component('b-dropdown', () => import(/* webpackChunkName: "b-dropdown" */ '@bv/dropdown/dropdown').then(m => {return m.BDropdown}))
Vue.component('b-dropdown-item', () => import(/* webpackChunkName: "b-dropdown-item" */ '@bv/dropdown/dropdown-item').then(m => {return m.BDropdownItem}))
Vue.component('b-dropdown-item-button', () => import(/* webpackChunkName: "b-dropdown-item-button" */ '@bv/dropdown/dropdown-item-button').then(m => {return m.BDropdownItemButton}))
Vue.component('b-dropdown-divider', () => import(/* webpackChunkName: "b-dropdown-divider" */ '@bv/dropdown/dropdown-divider').then(m => {return m.BDropdownDivider}))
Vue.component('b-dropdown-form', () => import(/* webpackChunkName: "b-dropdown-form" */ '@bv/dropdown/dropdown-form').then(m => {return m.BDropdownForm}))
Vue.component('b-dropdown-text', () => import(/* webpackChunkName: "b-dropdown-text" */ '@bv/dropdown/dropdown-text').then(m => {return m.BDropdownText}))
Vue.component('b-dropdown-group', () => import(/* webpackChunkName: "b-dropdown-group" */ '@bv/dropdown/dropdown-group').then(m => {return m.BDropdownGroup}))
Vue.component('b-dropdown-header', () => import(/* webpackChunkName: "b-dropdown-header" */ '@bv/dropdown/dropdown-header').then(m => {return m.BDropdownHeader}))

//  embed
Vue.component('b-embed', () => import(/* webpackChunkName: "b-embed" */ '@bv/embed/embed').then(m => {return m.BEmbed}))

//  form
Vue.component('b-form', () => import(/* webpackChunkName: "b-form" */ '@bv/form/form').then(m => {return m.BForm}))
Vue.component('b-form-text', () => import(/* webpackChunkName: "b-form-text" */ '@bv/form/form-text').then(m => {return m.BFormText}))
Vue.component('b-form-invalid-feedback', () => import(/* webpackChunkName: "b-form-invalid-feedback" */ '@bv/form/form-invalid-feedback').then(m => {return m.BFormInvalidFeedback}))
Vue.component('b-form-valid-feedback', () => import(/* webpackChunkName: "b-form-valid-feedback" */ '@bv/form/form-valid-feedback').then(m => {return m.BFormValidFeedback}))
Vue.component('b-form-datalist', () => import(/* webpackChunkName: "b-form-datalist" */ '@bv/form/form-datalist').then(m => {return m.BFormDatalist}))

//  form-checkbox
Vue.component('b-form-checkbox', () => import(/* webpackChunkName: "b-form-checkbox" */ '@bv/form-checkbox/form-checkbox').then(m => {return m.BFormCheckbox}))
Vue.component('b-form-checkbox-group', () => import(/* webpackChunkName: "b-form-checkbox-group" */ '@bv/form-checkbox/form-checkbox-group').then(m => {return m.BFormCheckboxGroup}))

//  form-datepicker
Vue.component('b-form-datepicker', () => import(/* webpackChunkName: "b-form-datepicker" */ '@bv/form-datepicker/form-datepicker').then(m => {return m.BFormDatepicker}))

//  form-file
Vue.component('b-form-file', () => import(/* webpackChunkName: "b-form-file" */ '@bv/form-file/form-file').then(m => {return m.BFormFile}))

//  form-group
Vue.component('b-form-group', () => import(/* webpackChunkName: "b-form-group" */ '@bv/form-group/form-group').then(m => {return m.BFormGroup}))

//  form-input
Vue.component('b-form-input', () => import(/* webpackChunkName: "b-form-input" */ '@bv/form-input/form-input').then(m => {return m.BFormInput}))

//  form-radio
Vue.component('b-form-radio', () => import(/* webpackChunkName: "b-form-radio" */ '@bv/form-radio/form-radio').then(m => {return m.BFormRadio}))
Vue.component('b-form-radio-group', () => import(/* webpackChunkName: "b-form-radio-group" */ '@bv/form-radio/form-radio-group').then(m => {return m.BFormRadioGroup}))

//  form-rating
Vue.component('b-form-rating', () => import(/* webpackChunkName: "b-form-rating" */ '@bv/form-rating/form-rating').then(m => {return m.BFormRating}))

//  form-select
Vue.component('b-form-select', () => import(/* webpackChunkName: "b-form-select" */ '@bv/form-select/form-select').then(m => {return m.BFormSelect}))
Vue.component('b-form-select-option', () => import(/* webpackChunkName: "b-form-select-option" */ '@bv/form-select/form-select-option').then(m => {return m.BFormSelectOption}))
Vue.component('b-form-select-option-group', () => import(/* webpackChunkName: "b-form-select-option-group" */ '@bv/form-select/form-select-option-group').then(m => {return m.BFormSelectOptionGroup}))

//  form-spinbutton
Vue.component('b-form-spinbutton', () => import(/* webpackChunkName: "b-form-spinbutton" */ '@bv/form-spinbutton/form-spinbutton').then(m => {return m.BFormSpinbutton}))

//  form-tags
Vue.component('b-form-tags', () => import(/* webpackChunkName: "b-form-tags" */ '@bv/form-tags/form-tags').then(m => {return m.BFormTags}))
Vue.component('b-form-tag', () => import(/* webpackChunkName: "b-form-tag" */ '@bv/form-tags/form-tag').then(m => {return m.BFormTag}))

//  form-textarea
Vue.component('b-form-textarea', () => import(/* webpackChunkName: "b-form-textarea" */ '@bv/form-textarea/form-textarea').then(m => {return m.BFormTextarea}))

//  form-timepicker
Vue.component('b-form-timepicker', () => import(/* webpackChunkName: "b-form-timepicker" */ '@bv/form-timepicker/form-timepicker').then(m => {return m.BFormTimepicker}))

//  image
Vue.component('b-img', () => import(/* webpackChunkName: "b-img" */ '@bv/image/img').then(m => {return m.BImg}))
Vue.component('b-img-lazy', () => import(/* webpackChunkName: "b-img-lazy" */ '@bv/image/img-lazy').then(m => {return m.BImgLazy}))

//  input-group
Vue.component('b-input-group', () => import(/* webpackChunkName: "b-input-group" */ '@bv/input-group/input-group').then(m => {return m.BInputGroup}))
Vue.component('b-input-group-prepend', () => import(/* webpackChunkName: "b-input-group-prepend" */ '@bv/input-group/input-group-prepend').then(m => {return m.BInputGroupPrepend}))
Vue.component('b-input-group-append', () => import(/* webpackChunkName: "b-input-group-append" */ '@bv/input-group/input-group-append').then(m => {return m.BInputGroupAppend}))
Vue.component('b-input-group-text', () => import(/* webpackChunkName: "b-input-group-text" */ '@bv/input-group/input-group-text').then(m => {return m.BInputGroupText}))
Vue.component('b-input-group-addon', () => import(/* webpackChunkName: "b-input-group-addon" */ '@bv/input-group/input-group-addon').then(m => {return m.BInputGroupAddon}))

//  jumbotron
Vue.component('b-jumbotron', () => import(/* webpackChunkName: "b-jumbotron" */ '@bv/jumbotron/jumbotron').then(m => {return m.BJumbotron}))

//  layout
Vue.component('b-container', () => import(/* webpackChunkName: "b-container" */ '@bv/layout/container').then(m => {return m.BContainer}))
Vue.component('b-row', () => import(/* webpackChunkName: "b-row" */ '@bv/layout/row').then(m => {return m.BRow}))
Vue.component('b-col', () => import(/* webpackChunkName: "b-col" */ '@bv/layout/col').then(m => {return m.BCol}))
Vue.component('b-form-row', () => import(/* webpackChunkName: "b-form-row" */ '@bv/layout/form-row').then(m => {return m.BFormRow}))

//  link
Vue.component('b-link', () => import(/* webpackChunkName: "b-link" */ '@bv/link/link').then(m => {return m.BLink}))

//  list-group
Vue.component('b-list-group', () => import(/* webpackChunkName: "b-list-group" */ '@bv/list-group/list-group').then(m => {return m.BListGroup}))
Vue.component('b-list-group-item', () => import(/* webpackChunkName: "b-list-group-item" */ '@bv/list-group/list-group-item').then(m => {return m.BListGroupItem}))

//  media
Vue.component('b-media', () => import(/* webpackChunkName: "b-media" */ '@bv/media/media').then(m => {return m.BMedia}))
Vue.component('b-media-aside', () => import(/* webpackChunkName: "b-media-aside" */ '@bv/media/media-aside').then(m => {return m.BMediaAside}))
Vue.component('b-media-body', () => import(/* webpackChunkName: "b-media-body" */ '@bv/media/media-body').then(m => {return m.BMediaBody}))

//  modal
Vue.component('b-modal', () => import(/* webpackChunkName: "b-modal" */ '@bv/modal/modal').then(m => {return m.BModal}))

//  nav
Vue.component('b-nav', () => import(/* webpackChunkName: "b-nav" */ '@bv/nav/nav').then(m => {return m.BNav}))
Vue.component('b-nav-item', () => import(/* webpackChunkName: "b-nav-item" */ '@bv/nav/nav-item').then(m => {return m.BNavItem}))
Vue.component('b-nav-text', () => import(/* webpackChunkName: "b-nav-text" */ '@bv/nav/nav-text').then(m => {return m.BNavText}))
Vue.component('b-nav-form', () => import(/* webpackChunkName: "b-nav-form" */ '@bv/nav/nav-form').then(m => {return m.BNavForm}))
Vue.component('b-nav-item-dropdown', () => import(/* webpackChunkName: "b-nav-item-dropdown" */ '@bv/nav/nav-item-dropdown').then(m => {return m.BNavItemDropdown}))

//  navbar
Vue.component('b-navbar', () => import(/* webpackChunkName: "b-navbar" */ '@bv/navbar/navbar').then(m => {return m.BNavbar}))
Vue.component('b-navbar-nav', () => import(/* webpackChunkName: "b-navbar-nav" */ '@bv/navbar/navbar-nav').then(m => {return m.BNavbarNav}))
Vue.component('b-navbar-brand', () => import(/* webpackChunkName: "b-navbar-brand" */ '@bv/navbar/navbar-brand').then(m => {return m.BNavbarBrand}))
Vue.component('b-navbar-toggle', () => import(/* webpackChunkName: "b-navbar-toggle" */ '@bv/navbar/navbar-toggle').then(m => {return m.BNavbarToggle}))

//  overlay
Vue.component('b-overlay', () => import(/* webpackChunkName: "b-overlay" */ '@bv/overlay/overlay').then(m => {return m.BOverlay}))

//  pagination
Vue.component('b-pagination', () => import(/* webpackChunkName: "b-pagination" */ '@bv/pagination/pagination').then(m => {return m.BPagination}))

//  pagination-nav
Vue.component('b-pagination-nav', () => import(/* webpackChunkName: "b-pagination-nav" */ '@bv/pagination-nav/pagination-nav').then(m => {return m.BPaginationNav}))

//  popover
Vue.component('b-popover', () => import(/* webpackChunkName: "b-popover" */ '@bv/popover/popover').then(m => {return m.BPopover}))

//  progress
Vue.component('b-progress', () => import(/* webpackChunkName: "b-progress" */ '@bv/progress/progress').then(m => {return m.BProgress}))
Vue.component('b-progress-bar', () => import(/* webpackChunkName: "b-progress-bar" */ '@bv/progress/progress-bar').then(m => {return m.BProgressBar}))

//  sidebar
Vue.component('b-sidebar', () => import(/* webpackChunkName: "b-sidebar" */ '@bv/sidebar/sidebar').then(m => {return m.BSidebar}))

//  skeleton
Vue.component('b-skeleton', () => import(/* webpackChunkName: "b-skeleton" */ '@bv/skeleton/skeleton').then(m => {return m.BSkeleton}))
Vue.component('b-skeleton-wrapper', () => import(/* webpackChunkName: "b-skeleton-wrapper" */ '@bv/skeleton/skeleton-wrapper').then(m => {return m.BSkeletonWrapper}))
Vue.component('b-skeleton-table', () => import(/* webpackChunkName: "b-skeleton-table" */ '@bv/skeleton/skeleton-table').then(m => {return m.BSkeletonTable}))
Vue.component('b-skeleton-img', () => import(/* webpackChunkName: "b-skeleton-img" */ '@bv/skeleton/skeleton-img').then(m => {return m.BSkeletonImg}))
Vue.component('b-skeleton-icon', () => import(/* webpackChunkName: "b-skeleton-icon" */ '@bv/skeleton/skeleton-icon').then(m => {return m.BSkeletonIcon}))

//  spinner
Vue.component('b-spinner', () => import(/* webpackChunkName: "b-spinner" */ '@bv/spinner/spinner').then(m => {return m.BSpinner}))

//  table
Vue.component('b-table', () => import(/* webpackChunkName: "b-table" */ '@bv/table/table').then(m => {return m.BTable}))
Vue.component('b-table-lite', () => import(/* webpackChunkName: "b-table-lite" */ '@bv/table/table-lite').then(m => {return m.BTableLite}))
Vue.component('b-table-simple', () => import(/* webpackChunkName: "b-table-simple" */ '@bv/table/table-simple').then(m => {return m.BTableSimple}))
Vue.component('b-tbody', () => import(/* webpackChunkName: "b-tbody" */ '@bv/table/tbody').then(m => {return m.BTbody}))
Vue.component('b-thead', () => import(/* webpackChunkName: "b-thead" */ '@bv/table/thead').then(m => {return m.BThead}))
Vue.component('b-tfoot', () => import(/* webpackChunkName: "b-tfoot" */ '@bv/table/tfoot').then(m => {return m.BTfoot}))
Vue.component('b-tr', () => import(/* webpackChunkName: "b-tr" */ '@bv/table/tr').then(m => {return m.BTr}))
Vue.component('b-td', () => import(/* webpackChunkName: "b-td" */ '@bv/table/td').then(m => {return m.BTd}))
Vue.component('b-th', () => import(/* webpackChunkName: "b-th" */ '@bv/table/th').then(m => {return m.BTh}))

//  tabs
Vue.component('b-tabs', () => import(/* webpackChunkName: "b-tabs" */ '@bv/tabs/tabs').then(m => {return m.BTabs}))
Vue.component('b-tab', () => import(/* webpackChunkName: "b-tab" */ '@bv/tabs/tab').then(m => {return m.BTab}))

//  time
Vue.component('b-time', () => import(/* webpackChunkName: "b-time" */ '@bv/time/time').then(m => {return m.BTime}))

//  toasts
Vue.component('b-toast', () => import(/* webpackChunkName: "b-toast" */ '@bv/toast/toast').then(m => {return m.BToast}))
Vue.component('b-toaster', () => import(/* webpackChunkName: "b-toaster" */ '@bv/toast/toaster').then(m => {return m.Btoaster}))

//  tooltip
Vue.component('b-tooltip', () => import(/* webpackChunkName: "b-tooltip" */ '@bv/tooltip/tooltip').then(m => {return m.BTooltip}))